import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { OverlaySimpleComponent } from '@toro/common/shared/components/dialogs/overlay-simple/overlay-simple.component';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { DialogGraphicComponent } from '../../../../components/dialogs/dialog-graphic/dialog-graphic.component';
import { StockCardsComponent } from '../../stock-cards.component';

@AutoUnsubscribe()
@Component({
    selector: 'analyse-card',
    templateUrl: './analyse-card.component.html',
})
export class AnalyseCardComponent extends StockCardsComponent implements OnInit, OnDestroy {

    @Input() public symbol: string;
    @Input() public aboutCompanyText: string;

    public unitPrice: number = 0;
    public variation: number = 0;
    public highestPriceDay: number = 0;
    public lowestPriceDay: number = 0;
    public companyName: string = '';
    public logo: string = '';
    public isFuture: boolean = false;

    public quote: any = null;
    public quoteInfo: any = null;
    public instrument: any = null;

    private quoteSubscription: Subscription;
    private quoteInfoSubscription: Subscription;
    private instrumentSubscription: Subscription;

    constructor(
        protected router: Router,
        protected dialogsServices: DialogsService,
        protected store: Store<AppState>,
        protected changeDetectorRef: ChangeDetectorRef,
    ) {
        super(router, dialogsServices, store, changeDetectorRef);
    }

    public ngOnInit() {

        // Recupera os dados de cotação
        this.quoteSubscription = this.store.select((s) => s.stocksExchange.stocksMarket.quote)
            .filter((quote) => !!quote[this.symbol])
            .map((quote) => quote[this.symbol])
            .subscribe((data) => {
                this.quote = data;
                this.unitPrice = this.quote.PriceLastTrade || this.quote.OpeningPrice || this.quote.ClosingPricePreviousDay;
                this.variation = this.quote.Variation || this.variation;
                this.highestPriceDay = this.quote.HighestPriceDay || this.highestPriceDay;
                this.lowestPriceDay = this.quote.LowestPriceDay || this.lowestPriceDay;
            });

        this.quoteInfoSubscription = this.store.select((s) => s.stocksExchange.stocksMarket.quoteInfo)
        .subscribe((data) => {
            this.quoteInfo = data;
            this.unitPrice = this.quoteInfo.priceLastTrade || this.quoteInfo.openingPrice || this.quoteInfo.closingPricePreviousDay;
            this.variation = this.quoteInfo.variation;
            this.highestPriceDay = this.quoteInfo.highestPriceDay;
            this.lowestPriceDay = this.quoteInfo.lowestPriceDay;
        });

        // Recupera os dados de instrumento
        this.instrumentSubscription = this.store.select((s) => s.stocksExchange.stocksMarket.instruments)
            .filter((f) => !!f[this.symbol])
            .map((m) => m[this.symbol])
            .subscribe((data) => {
                this.instrument = data;
                this.unitPrice = this.instrument.priceLastTrade || this.instrument.openingPrice || this.instrument.closingPricePreviousDay;
                this.isFuture = this.instrument ? this.instrument.typeMarket === OrderMarketTypeEnum.Future : false;
                this.companyName = data.descriptionStock;
                this.logo = data.logo.content;
            });

        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbol });
        this.store.dispatch({ type: StocksMarketAction.getQuoteInfo, payload: this.symbol });
        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.symbol });
    }

    /**
     * Abre o overlay com o grafico
     */
    public openGraphicOverlay() {
        this.dialogsService.showComponnent(
            DialogGraphicComponent,
            {
                name: this.companyName,
                sticker: this.symbol,
                market: this.instrument.typeMarket,
                logoPath: this.instrument.logo ? this.instrument.logo.content : null,
            },
        );
    }

    /**
     * Abre o modal com dados sobre a empresa
     */
    public openAboutCompany() {
        this.dialogsService.showComponnent(
            OverlaySimpleComponent,
            {
                title: `Sobre a ${this.companyName}`,
                content: this.aboutCompanyText,
                closeButton: 'Fechar',
            },
        );
    }

    public ngOnDestroy() {
        this.store.dispatch({ type: StocksMarketAction.unsubscribeQuotes, payload: [this.symbol] });
    }

}
